export default __webpack_public_path__ + "static/media/fendt-820-vario-tms.0dedd181.jpg";